module.exports = __webpack_public_path__ + "static/man_with_documents-c9b9ed8e9dca193f0e7ad11567c5c191.svg";